import React from 'react';
import { useTranslation } from 'react-i18next';
import './Properties.css';

// Recebe um tipo de categoria e o seu respectivo valor
const Properties = ({ categories }) => {
  const { t } = useTranslation();
  // Filter para o environmental
const generalCategories = categories.filter(c => c.group === "general");
const environmentalCategories = categories.filter(c => c.group === "environmental");

  return (
    <div className="properties-full-container">
      <div className="properties-title-map">
        <div className="properties-subtitle">{t('general')}</div>
        <div className="categoria-container">
          {generalCategories.map((category, index) => (
            <div key={category.id || index} className="categoria-item">
              <div className="item-info">
                <p className="name">{category.name}</p>
                <p className="properties-description">{category.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <div className="properties-line"></div>
      <div className="properties-title-map">
        <div className="properties-subtitle">{t('environmental')}</div>
        <div className="categoria-container">
          {environmentalCategories.map((category, index) => (
            <div key={category.id || index} className="categoria-item">
              <div className="item-info">
                <p className="name">{category.name}</p>
                <p className="properties-description">{category.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default Properties;
